import React from 'react';
import PreviewCard from './PreviewCard';
import { spycraftMixedArrType } from '../proptypes/spycraft';

const SpycraftCardDeck = ({
  content: [podcastContent, videoContent, articleContent],
}) => (
  <div className="row">
    <div className="d-flex mb-2 mb-md-3 mb-lg-0 col-12 col-lg-8">
      <PreviewCard key={podcastContent.id} {...podcastContent} />
    </div>
    <div className="col-12 col-lg-4">
      <div className="row">
        <div className="d-flex mb-2 mb-md-0 mb-lg-3 col-12 col-md-6 col-lg-12">
          <PreviewCard key={videoContent.id} {...videoContent} />
        </div>
        <div className="d-flex col-12 col-md-6 col-lg-12">
          <PreviewCard key={articleContent.id} {...articleContent} />
        </div>
      </div>
    </div>
  </div>
);

SpycraftCardDeck.propTypes = {
  content: spycraftMixedArrType.isRequired,
};

export default SpycraftCardDeck;
